"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconFlagUk = void 0;
var React = __importStar(require("react"));
var IconFlagUk = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("g", { fill: "none", fillRule: "evenodd", transform: "translate(2 5)" },
        React.createElement("polygon", { fill: "#003874", points: "16.25 9.31 19.999 11.715 19.999 9.31" }),
        React.createElement("polygon", { fill: "#003874", points: "11.796 0 11.796 4.108 18.213 0" }),
        React.createElement("polygon", { fill: "#003874", points: "0 4.654 3.727 4.654 0 2.252" }),
        React.createElement("polygon", { fill: "#003874", points: "1.764 0 8.182 4.108 8.182 0" }),
        React.createElement("polygon", { fill: "#003874", points: "11.796 13.965 18.213 13.965 11.796 9.856" }),
        React.createElement("polygon", { fill: "#003874", points: "1.764 13.965 8.182 13.965 8.182 9.856" }),
        React.createElement("polygon", { fill: "#003874", points: "16.25 4.654 19.999 4.654 19.999 2.248" }),
        React.createElement("polygon", { fill: "#003874", points: "0 9.31 0 11.712 3.727 9.31" }),
        React.createElement("path", { fill: "#FFF", d: "M11.0752 13.9648L11.7962 13.9648 11.7962 9.8558 18.2132 13.9648 19.1732 13.9648C19.5152 13.9018 19.8012 13.6798 19.9262 13.3628L13.6312 9.3108 15.3742 9.3108 20.0002 12.2988 20.0002 11.7148 16.2502 9.3108 20.0002 9.3108 20.0002 8.3468 11.0752 8.3468 11.0752 13.9648zM8.124 9.3105L.874 13.9645 1.764 13.9645 8.182 9.8555 8.182 13.9645 8.951 13.9645 8.951 8.3465 0 8.3465 0 9.3105 3.727 9.3105 0 11.7125 0 12.9995C0 13.1285.029 13.2505.074 13.3645L6.389 9.3105 8.124 9.3105zM20 5.6196L20 4.6536 16.25 4.6536 20 2.2486 20 .9996C20 .8606 19.971.7286 19.918.6076L13.639 4.6566 11.903 4.6566 19.116.0236C19.076.0186 19.041-.0004 19-.0004L18.213-.0004 11.796 4.1086 11.796-.0004 11.075-.0004 11.075 5.6196 20 5.6196zM8.9512 0L8.1812 0 8.1812 4.108 1.7642 0 1.0402 0C.6202 0 .2612.254.0972.614L6.4032 4.657 4.6522 4.657.0002 1.666.0002 2.252 3.7262 4.653.0002 4.653.0002 5.62 8.9512 5.62 8.9512 0z" }),
        React.createElement("path", { fill: "#DC3A43", d: "M13.6387 4.6567L19.9177.6077C19.7807.2867 19.4747.0677 19.1167.0237L11.9037 4.6567 13.6387 4.6567zM13.6309 9.3105L19.9259 13.3635C19.9709 13.2495 19.9999 13.1285 19.9999 12.9995L19.9999 12.2985 15.3739 9.3105 13.6309 9.3105zM6.4033 4.6567L.0963.6147C.0373.7447.0003.8867.0003 1.0397L.0003 1.6657 4.6523 4.6567 6.4033 4.6567zM8.124 9.3105L6.389 9.3105.074 13.3645C.199 13.6805.484 13.9025.827 13.9645L.874 13.9645 8.124 9.3105z" }),
        React.createElement("polygon", { fill: "#DC3A43", points: "8.951 13.965 11.075 13.965 11.075 8.347 20 8.347 20 5.62 11.075 5.62 11.075 0 8.951 0 8.951 5.62 0 5.62 0 8.347 8.951 8.347" })))); };
exports.IconFlagUk = IconFlagUk;
exports.IconFlagUk.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconFlagUk;
